export default __webpack_public_path__ + "static/media/Hauora-Regular.dfdd82c3.woff2";